import { ApiPost } from "../helpers/API/ApiData";
import { getUserInfo } from "./user.util";
import Auth from "../helpers/Auth";

export function getImportActor() {
  const user = getUserInfo() || Auth.getUserDetail() || {};
  return {
    userId: user._id || user.id || "",
    name:
      user.name ||
      user.businessName ||
      user.fullName ||
      [user.firstName, user.lastName].filter(Boolean).join(" ") ||
      "",
    email: user.email || "",
    role: user.role || "",
  };
}

/**
 * Persist an import audit log. Best-effort — does not throw to caller.
 */
export async function postImportAuditLog({
  companyId,
  businessName,
  importType,
  fileName,
  totalRecords,
  successCount,
  failedCount,
  createdCount,
  updatedCount,
  skippedCount,
  logs,
}) {
  if (!companyId) return { ok: false, error: "missing companyId" };
  try {
    const payload = {
      companyId,
      businessName: businessName || "",
      importType,
      fileName: fileName || "",
      source: "admin-web",
      importedBy: getImportActor(),
      totalRecords: totalRecords || 0,
      successCount: successCount || 0,
      failedCount: failedCount || 0,
      createdCount: createdCount || 0,
      updatedCount: updatedCount || 0,
      skippedCount: skippedCount || 0,
      logs: (logs || []).slice(-200).map((l) => ({
        rowNumber: l.rowNumber || 0,
        name: l.name || "",
        status: l.type || l.status || "",
        reason: l.message || l.reason || "",
        action: l.action || l.type || "",
      })),
    };
    await ApiPost("importLog", payload);
    return { ok: true };
  } catch (e) {
    console.warn("Failed to write import audit log", e);
    return { ok: false, error: e };
  }
}
